<div class="modal-header">
    <h4 class="modal-title">
        <ng-container *ngIf="data">
            Edit Salon Chain Data
        </ng-container>
        <ng-container *ngIf="!data">
            Create Salon Chain Data
        </ng-container>
    </h4>
    <button type="button" class="btn-close focus:outline-none focus:shadow-none" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <i class="fas fa-times fa-1x"></i>
    </button>
</div>
<div class="modal-body">
    <div class="flex flex-row justify-between">
        <div class="flex flex-column basis-2/6" style="flex-basis: 33.333333%;">
            <div class="py-2">
                <span>Name</span>
                <dx-text-box
                        [(value)]="salonName"
                        [showClearButton]="true"
                        placeholder="Enter Salon name"
                >
                    <dx-validator>
                        <dxi-validation-rule
                                type="required"
                                message="Salon Name Required"
                        >
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            <div class="py-2">
                <span>Website</span>
                <dx-text-box
                        [(value)]="salonWebsite"
                        [showClearButton]="true"
                        placeholder="Enter Salon website"
                >
                </dx-text-box>
            </div>
        </div>
        <div class="flex flex-column basis-2/6" style="flex-basis: 33.333333%;">
            <div class="py-2">
                <span>Comment</span>
                <dx-text-box
                        [(value)]="salonComment"
                        [showClearButton]="true"
                        placeholder="Enter Salon comment"
                >
                </dx-text-box>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <dx-button
            icon="check"
            type="success"
            text="Save"
            (onClick)="saveSalonChainData($event)"
    >
    </dx-button>
    <dx-button
            icon="close"
            text="Cancel"
            (onClick)="activeModal.dismiss('Cross click')"
    >
    </dx-button>
</div>
